import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  DatePicker,
  Select,
  Row,
  Col,
  message,
  Typography,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

const CustomerAgreementForm = ({ formData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [passengers, setPassengers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [inspections, setInspections] = useState([]);

  useEffect(() => {
    fetchDropdownData();
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? moment(formData.startDate) : null,
        endDate: formData.endDate ? moment(formData.endDate) : null,
      });

      if (formData.agreementDocument) {
        setFileList([
          {
            uid: "-1",
            name: "Uploaded Document",
            status: "done",
            url: `http://93.127.203.113:5005${formData.agreementDocument}`,
          },
        ]);
      }
    }
  }, [formData]);

  const fetchDropdownData = async () => {
    try {
      const [passengersResponse, vehiclesResponse, inspectionsResponse] = await Promise.all([
        axios.get("http://93.127.203.113:5005/passengers"),
        axios.get("http://93.127.203.113:5005/vehicles"),
        axios.get("http://93.127.203.113:5005/inspections"),
      ]);
      setPassengers(passengersResponse.data);
      setVehicles(vehiclesResponse.data);
      setInspections(inspectionsResponse.data);
    } catch (error) {
      message.error("Failed to fetch dropdown data.");
    }
  };

  const handleFileChange = ({ file, fileList }) => {
    if (file.status === "removed") {
      setFile(null);
      setFileList([]);
    } else {
      setFile(file.originFileObj);
      setFileList(fileList);
    }
  };

  const onFinish = async (values) => {
    const payload = new FormData();

    Object.keys(values).forEach((key) => {
      payload.append(key, values[key]);
    });

    payload.set("startDate", values.startDate.format("YYYY-MM-DD"));
    if (values.endDate) {
      payload.set("endDate", values.endDate.format("YYYY-MM-DD"));
    }

    if (file) {
      payload.append("agreementDocument", file);
    }

    try {
      if (formData.agreementId) {
        await axios.put(`http://93.127.203.113:5005/customer-agreements/${formData.agreementId}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Agreement updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/customer-agreements", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Agreement created successfully");
      }

      refetchData();
      closeModal();
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save agreement.");
    }
  };

  return (
    <div style={{ padding: "20px", borderRadius: "10px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData.agreementId ? "Edit Agreement" : "Create Agreement"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Passenger" name="passengerId" rules={[{ required: true, message: "Please select a passenger" }]}>
              <Select placeholder="Select a passenger">
                {passengers.map((passenger) => (
                  <Option key={passenger.id} value={passenger.id}>
                    {passenger.firstName} {passenger.lastName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Vehicle" name="vehicleId" rules={[{ required: true, message: "Please select a vehicle" }]}>
              <Select placeholder="Select a vehicle">
                {vehicles.map((vehicle) => (
                  <Option key={vehicle.id} value={vehicle.id}>
                    {vehicle.plateNumber} ({vehicle.model})
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Inspection" name="vehicleInspectionId" rules={[{ required: true, message: "Please select an inspection" }]}>
              <Select placeholder="Select an inspection">
                {inspections.map((inspection) => (
                  <Option key={inspection.id} value={inspection.id}>
                    {inspection.inspectionDate} - {inspection.fuelStatus}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Price Per Day" name="pricePerDay" rules={[{ required: true, message: "Please enter price per day" }]}>
              <Input type="number" placeholder="Enter price per day" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Start Date" name="startDate" rules={[{ required: true, message: "Please select a start date" }]}>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="End Date" name="endDate">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Agreement Document">
              <Upload
                listType="text"
                fileList={fileList}
                beforeUpload={(file) => {
                  setFile(file);
                  setFileList([file]);
                  return false;
                }}
                onRemove={() => {
                  setFile(null);
                  setFileList([]);
                }}
              >
                <Button icon={<UploadOutlined />}>Upload Agreement</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => {
              form.resetFields();
              setFile(null);
              setFileList([]);
            }}
            style={{ marginLeft: "10px" }}
          >
            Reset
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CustomerAgreementForm;
